import { render, staticRenderFns } from "./add-order.vue?vue&type=template&id=5cd7f4c8&scoped=true&"
import script from "./add-order.vue?vue&type=script&lang=js&"
export * from "./add-order.vue?vue&type=script&lang=js&"
import style0 from "./add-order.vue?vue&type=style&index=0&id=5cd7f4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7f4c8",
  null
  
)

export default component.exports